<template>
  <div class="pingtai_module">
    <div class="pingtai-cup">
      <div v-for="(item,index) in pingtaiArr" :key="index" class="pingtai_item">
        <a :href="item.url" target="_blank" class="jump-cup">
          <img :src="item.path" alt class="img_main" />
          <div class="subTitle pingtai_text">{{item.name}}</div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pingtaiArr: [
        {
          path: '../../../../static/img/pingtai/pingtai1.png',
          name: '智能农机装备管理平台',
          url: 'http://yg.chiaic.com'
        },
        {
          path: '../../../../static/img/pingtai/pingtai2.png',
          name: '河南农机云平台',
          url: 'http://ham.chiaic.com/login'
        },
        {
          path: '../../../../static/img/pingtai/pingtai3.png',
          name: '淮滨县智慧农业管理平台',
          url: 'http://huaibin.chiaic.com/'
        }
      ],
      symbolHover: false
    };
  },
  watch: {
    symbolHover: {
      deep: true,
      handler(val) {
        console.log(val);
      }
    }
  },
  methods: {
    // flyToTheOne (item) {
    //   window.open(item.url);
    // },
    // throttle (fn, space) {
    //   let task = null;
    //   return function () {
    //     if (!task) {
    //       task = setTimeout(function () {
    //         task = null;
    //         fn.apply(this, arguments);
    //       }, space);
    //     }
    //   }
    // },
    // doThrottle () {
    //   this.throttle();
    // }
  }
};
</script>
<style scoped>
.pingtai_module {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.pingtai-cup {
  width: 60%;
  overflow: hidden;
  margin: 0 auto;
  padding: 18px 0 10px;
}

.pingtai_item {
  float: left;
  width: 33%;
  cursor: pointer;
  text-align: center;
  padding: 0 auto;
}
.pingtai_text {
  color: #00697f;
}

.img_main {
  border: 1px double #f3f3f3;
  border-radius: 80px;
}

.img_main:hover {
  border: 1px solid #f3f3f3;
  border-radius: 80px;
  box-shadow: 0 0 20px #00697f;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/pingtai.vue